export default __webpack_public_path__ + "static/media/480_business02-es-web.41aa1a7f.png";